export default {

  props: [
    'propImages'
  ],

  data () {
    return {
      extensions: [],
      computed:   {
        images: null
      }
    }
  },

  created () {
    this.extensions = [
      'pdf',
      'doc',
      'docx',
      'xls',
      'xlsx',
      'csv',
      'pptx',
      'txt',
      'htm',
      'mp3',
      'jpeg',
      'jpg',
      'JPG',
      'JPEG',
      'gif',
      'GIF',
      'png',
      'PNG',
      ''
    ]
  },

  computed: {
    images: {
      get: function () {
        if (this.computed.images) {
          return this.computed.images
        }

        return this.propImages
      }
    }
  }
}
